import axios from 'axios'
const endpoint = process.env.VUE_APP_BASE_API + '/api/master/buying/override/CancellationSurcharges'

export default {
  async getAll(policyId) {
    return await axios
      .get(endpoint + `/list/${policyId}`)
      .then(response => {
        return response.data.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async create(request) {
    return await axios
      .post(endpoint, request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async update(request) {
    return await axios
      .put(endpoint, request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async delete(id) {
    return await axios
      .delete(endpoint + `/${id}`)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  }
}



// WEBPACK FOOTER //
// ./src/services/master/buyingTariff/buyingTariffOverriddenCancellationSurchargeService.js